import {
    GET_ONE,
    UPDATE,
    DELETE,
} from 'admin-on-rest/lib/rest/types';

export const CRUD_GET_ONE = 'AOR/CRUD_GET_ONE';
export const CRUD_GET_ONE_LOADING = 'AOR/CRUD_GET_ONE_LOADING';
export const CRUD_GET_ONE_FAILURE = 'AOR/CRUD_GET_ONE_FAILURE';
export const CRUD_GET_ONE_SUCCESS = 'AOR/CRUD_GET_ONE_SUCCESS';

export const crudGetOne = (resource,
                           location_id,
                           transfer_id,
                           basePath,
                           cancelPrevious = true) => ({
    type: CRUD_GET_ONE,
    payload: {location_id, transfer_id, basePath},
    meta: {resource, fetch: GET_ONE, cancelPrevious},
});

export const CRUD_UPDATE = 'AOR/CRUD_UPDATE';
export const CRUD_UPDATE_LOADING = 'AOR/CRUD_UPDATE_LOADING';
export const CRUD_UPDATE_FAILURE = 'AOR/CRUD_UPDATE_FAILURE';
export const CRUD_UPDATE_SUCCESS = 'AOR/CRUD_UPDATE_SUCCESS';

export const crudUpdate = (resource,
                           transfer_id,
                           location_id,
                           data,
                           previousData,
                           basePath,
                           redirectTo = 'list') => ({
    type: CRUD_UPDATE,
    payload: {transfer_id, location_id, data, previousData, basePath, redirectTo},
    meta: {resource, fetch: UPDATE, cancelPrevious: false},
});

export const CRUD_DELETE = 'AOR/CRUD_DELETE';
export const CRUD_DELETE_LOADING = 'AOR/CRUD_DELETE_LOADING';
export const CRUD_DELETE_FAILURE = 'AOR/CRUD_DELETE_FAILURE';
export const CRUD_DELETE_SUCCESS = 'AOR/CRUD_DELETE_SUCCESS';

export const crudDelete = (resource,
                           location_id,
                           transfer_id,
                           previousData,
                           basePath,
                           redirectTo = 'list') => ({
    type: CRUD_DELETE,
    payload: {location_id, transfer_id, previousData, basePath, redirectTo},
    meta: {resource, fetch: DELETE, cancelPrevious: false},
});


// WEBPACK FOOTER //
// ./src/Fuse/admin/dataActionsInventoryTransfer.js